import moment from 'moment';
import 'moment/locale/ru';
import { formatBytes, formatCurrency, formatDate, formatDateTime, formatDateTimeSeconds, formatNumber, formatUnixTimestamp, plural } from './format';

moment.locale('ru');

/**
 * Фильтры форматирования ru-RU для AngularJS-шаблонов.
 * Обертки над общими функциями из ./format — собственной логики не содержат.
 */
angular
  .module('shbdeployer.app')
  .filter('ruDate', () => formatDate)
  .filter('ruDateTime', () => formatDateTime)
  .filter('ruDateTimeSeconds', () => formatDateTimeSeconds)
  .filter('ruUnixTimestamp', () => formatUnixTimestamp)
  .filter('ruNumber', () => formatNumber)
  .filter('ruCurrency', () => formatCurrency)
  .filter('ruBytes', () => (value, decimals) => formatBytes(value, decimals))
  .filter('ruPlural', () => (count, one, few, many) => plural(count, [one, few, many]));
